var exports = {
  "kL": "BaseAvatar.module__container___NjlTYV",
  "vk": "BaseAvatar.module__clickable___NjlTYV",
  "Lw": "BaseAvatar.module__overlay___NjlTYV",
  "Sl": "BaseAvatar.module__image___NjlTYV",
  "qf": "BaseAvatar.module__placeholder___NjlTYV",
  "ci": "BaseAvatar.module__placeholderFastFade___NjlTYV",
  "Ap": "BaseAvatar.module__placeholderVisible___NjlTYV",
  "uR": "BaseAvatar.module__placeholderHidden___NjlTYV",
  "n_": "BaseAvatar.module__hoverOverlay___NjlTYV",
  "II": "BaseAvatar.module__statusContainer___NjlTYV",
  "mH": "BaseAvatar.module__statusTooltipDisabled___NjlTYV",
  "VN": "BaseAvatar.module__reducedMotion___NjlTYV",
  "BC": "BaseAvatar.module__animatedMaskShape___NjlTYV",
  "Qb": "BaseAvatar.module__animatedMaskReducedMotion___NjlTYV",
  "AP": "BaseAvatar.module__typingBubble___NjlTYV",
  "y5": "BaseAvatar.module__typingDots___NjlTYV",
  "BI": "BaseAvatar.module__typingDot___NjlTYV",
  "Zm": "BaseAvatar.module__blink___NjlTYV",
  "fQ": "BaseAvatar.module__customStatusBadge___NjlTYV",
  "Bp": "BaseAvatar.module__customStatusBadgeBackground___NjlTYV",
  "Go": "BaseAvatar.module__customStatusBadgeContent___NjlTYV",
};

module.exports = exports;
